const getWhitepaper2024EmailFormName = require("./getWhitepaper2024EmailFormName");
const sendFormSubmissionStartedEmailToFormsAtIterableCom = require("../email/sendFormSubmissionStartedEmailToFormsAtIterableCom");

/**
 * @param whitepaper2024FormData {Whitepaper2024FormData}
 * @return {Promise<void>}
 */
module.exports = async function sendWhitepaper2024FormSubmissionStartedEmailToFormsAtIterableCom(whitepaper2024FormData) {
    const formName = getWhitepaper2024EmailFormName();
    const email = whitepaper2024FormData['Email'];
    const formid = whitepaper2024FormData['formid'];
    await sendFormSubmissionStartedEmailToFormsAtIterableCom(formName, email, formid, whitepaper2024FormData);
}